import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from 'flowbite-react';
import { setBenefitList } from '../../redux/benefitList/benefitSlice';

import axios from 'axios';

const BenefitHistory = () => {
  const dispatch = useDispatch();
  const { benefitList = [], loading = false } = useSelector((state) => state.benefits || {});
  const { currentUser } = useSelector((state) => state.user || {});
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBenefits = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}benefit/getUserBenefit`,
          { applicantId: currentUser?._id },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        console.log('Benefit History Response:', response.data);
        dispatch(setBenefitList(response.data.data || []));
      } catch (err) {
        setError(err.message || 'Failed to fetch benefit history');
        toast.error('Failed to fetch benefit history');
      }
    };
    if (currentUser?._id) fetchBenefits();
  }, [dispatch, currentUser?._id]);

  if (loading) return <div className="p-4 text-center">Loading benefit history...</div>;
  if (error) return <div className="p-4 text-red-500">{error}</div>;

  return (
    <div className="p-4 bg-white rounded-lg shadow w-full max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Benefit Request History</h2>
      <Table className="w-full border-collapse">
        <Table.Head className="bg-gray-200">
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">S/N</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Benefit Type</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Amount Requested</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Reason</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Status</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Date Requested</Table.HeadCell>
        </Table.Head>
        <Table.Body>
          {benefitList.map((benefit, index) => (
            <Table.Row
              key={benefit?._id}
              className={`border-t ${
                benefit?.benefitStatus === 'Pending'
                  ? 'bg-yellow-50'
                  : benefit?.benefitStatus === 'Approved'
                  ? 'bg-green-50'
                  : benefit?.benefitStatus === 'rejected'
                  ? 'bg-red-50'
                  : ''
              }`}
            >
              <Table.Cell className="border-gray-200 text-sm font-medium text-gray-600 px-6 py-4">
                {index + 1}
              </Table.Cell>
              <Table.Cell className="border-gray-200 text-sm font-medium text-gray-600 px-6 py-4">
                {benefit?.benefitType || 'N/A'}
              </Table.Cell>
              <Table.Cell className="border-gray-200 text-sm font-medium text-gray-600 px-6 py-4">
                N{benefit?.amountRequested || '0'}
              </Table.Cell>
              <Table.Cell className="border-gray-200 text-sm font-medium text-gray-600 px-6 py-4">
                {benefit?.benefitDescription || 'N/A'}
              </Table.Cell>
              <Table.Cell className="border-gray-200 text-sm font-medium text-gray-600 px-6 py-4">
                <span
                  className={`flex w-full items-center justify-center ${
                    benefit?.benefitStatus === 'Approved'
                      ? 'text-green-600'
                      : benefit?.benefitStatus === 'rejected'
                      ? 'text-red-600'
                      : 'text-yellow-600'
                  }`}
                >
                  {benefit?.benefitStatus || 'Unknown'}
                </span>
              </Table.Cell>
              <Table.Cell className="border-gray-200 text-sm font-medium text-gray-600 px-6 py-4">
                {new Date(benefit?.createdAt).toLocaleDateString() || 'N/A'}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      {benefitList.length === 0 && !loading && (
        <p className="text-center text-gray-500 mt-4">No benefit requests found.</p>
      )}
    </div>
  );
};

export default BenefitHistory;